import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    left: ${`${displayState.progress}%`};
    transform: ${displayState?.moveLeft ? `translateX(-100%)` : ''};
    top: ${`${displayState.top ? displayState.top : 24}px`};
    font-weight: 400;
    position: absolute;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.06em;
    color: #9EACB0;
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })